import { Box, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, Text, VStack } from '@chakra-ui/react';
import React, { useContext, useState } from 'react';
import { AccountContext } from 'components/AccountContext';
import { getAppTheme, userIsSubscriber } from 'components/Utils/theme';
import useViewModalNotificacao from './useViewModalNotificacao';
import { IoMdClose } from 'react-icons/io';
import useRoutes from 'components/Utils/Functions/useRoutes';

function ModalNotificacao(props) {
  const disclosure = props.disclosure;
  const notificacoes = [...(props.cacheNotificacao || []), ...(props.notificacoes_sns || [])];
  const refetch = props.refetch;
  const { user, setUser } = useContext(AccountContext);
  const theme = getAppTheme(userIsSubscriber(user));

  const { handleReadNotification } = useViewModalNotificacao({ refetch });
  const navigateByRoute = useRoutes();
  const [mostrarTodas, setMostrarTodas] = useState(false);

  const marcarComoLidaLocal = (id) => {
    setUser((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        cache_notificacao: prev.cache_notificacao?.map((n) => (n.id === id ? { ...n, lida: true, data_leitura: new Date() } : n)),
      };
    });
  };

  return (
    <Modal isOpen={disclosure.isOpen} onClose={disclosure.onClose} isCentered>
      <ModalOverlay />
      <ModalContent maxW="90%" h="auto" borderRadius="0.8em" p={4}>
        <ModalCloseButton />

        <ModalBody width={'100%'} p={0} m={0}>
          <VStack width={'100%'} spacing={4} p={0} m={0}>
            <Text color={theme.color} fontWeight="bold" fontSize="2xl" textAlign="center">
              Notificações
            </Text>

            <VStack spacing={3} w="100%" maxHeight={'70dvh'} overflowY={'auto'}>
              {notificacoes?.length === 0 && (
                <Text color={'gray.400'} fontWeight="bold" fontSize="lg" textAlign="center">
                  Sem notificações
                </Text>
              )}

              {(mostrarTodas ? notificacoes : notificacoes.slice(0, 5))?.map((notificacao) => {
                let titulo = notificacao.titulo;
                let mensagem = notificacao.mensagem;
                let data = notificacao.data || {};

                if (!titulo && notificacao.conteudo_json) {
                  let conteudo = notificacao.conteudo_json;

                  if (typeof conteudo === 'string') {
                    conteudo = JSON.parse(conteudo);
                  }

                  const notification = conteudo?.notification || conteudo?.rawMessage?.content || {};

                  titulo = notification?.title || 'Notificação';
                  mensagem = notification?.body || notification?.message || '';

                  data = notification?.data || {};
                }

                const naoLida = !notificacao.lida;

                return (
                  <VStack
                    key={notificacao.id}
                    position={'relative'}
                    border={naoLida ? `2px solid ${theme.color}` : `1px solid ${theme.background}`}
                    background={naoLida ? '#f0f7ff' : 'white'}
                    width={'100%'}
                    align={'flex-start'}
                    p={4}
                    borderRadius={'0.8em'}
                    spacing={2}
                    cursor={data?.rota ? 'pointer' : 'default'}
                    opacity={naoLida ? 1 : 0.6}
                    _hover={{ background: data?.rota ? '#f7f7f7' : 'transparent' }}
                    onClick={() => {
                      if (data?.rota) {
                        marcarComoLidaLocal(notificacao.id);
                        navigateByRoute(data);
                        handleReadNotification(notificacao.id, data?.rota);
                        disclosure.onClose();
                      }
                    }}
                  >
                    <Box position={'absolute'} top={5} right={5}>
                      <IoMdClose
                        color={theme.color}
                        size="20px"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleReadNotification(notificacao.id, data?.rota);
                          if(data?.rota) {
                            marcarComoLidaLocal(notificacao.id);
                          }
                        }}
                      />
                    </Box>

                    <HStack spacing={2} align="center">
                      <Text fontWeight="bold" color={theme.color}>
                        {titulo}
                      </Text>

                      {naoLida && (
                        <Box fontSize="10px" fontWeight="bold" color="white" bg={theme.color} px={2} py="2px" borderRadius="6px">
                          NOVA
                        </Box>
                      )}
                    </HStack>

                    <Text fontSize="sm">{mensagem}</Text>
                  </VStack>
                );
              })}

              {!mostrarTodas && notificacoes?.length > 5 && (
                <Text cursor="pointer" fontWeight="bold" color={theme.color} onClick={() => setMostrarTodas(true)}>
                  Ver mais notificações
                </Text>
              )}
            </VStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default ModalNotificacao;
